import { useState } from "react";
import { Badge, Input, PageHeader } from "@fellowflats/ui";
import { OkSchema } from "@fellowflats/contracts/account-writes";
import { UsersSchema } from "@fellowflats/contracts/admin";
import { api } from "../lib/api";
import { useApi } from "../lib/use-api";
import { ActionButton, Loaded, day } from "../components/bits";

export function People() {
  const [q, setQ] = useState("");
  const [term, setTerm] = useState("");
  const state = useApi(() => api("GET", `/admin/users${term ? `?q=${encodeURIComponent(term)}` : ""}`, UsersSchema), term);
  return (
    <div className="space-y-6">
      <PageHeader title="People" description="Find an account by name or email. Newest first, 50 at most." />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setTerm(q.trim());
        }}
      >
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or email, then Enter" aria-label="Search people" />
      </form>
      <Loaded state={state}>
        {(people) => (
          <div className="overflow-x-auto rounded-lg border border-border">
            <table className="w-full text-left text-sm">
              <thead className="bg-muted text-xs uppercase text-muted-foreground">
                <tr>
                  <th className="px-3 py-2">Person</th>
                  <th className="px-3 py-2">Role</th>
                  <th className="px-3 py-2">Joined</th>
                  <th className="px-3 py-2">Last seen</th>
                  <th className="px-3 py-2" />
                </tr>
              </thead>
              <tbody>
                {people.map((p) => (
                  <tr key={p.id} className="border-t border-border">
                    <td className="px-3 py-2">
                      <p className="font-medium">{p.fullName ?? "-"}</p>
                      <p className="text-muted-foreground">{p.email}</p>
                    </td>
                    <td className="space-x-1 px-3 py-2">
                      {p.isAdmin && <Badge tone="primary">admin</Badge>}
                      {p.isLandlord && <Badge tone={p.verifiedLandlord ? "success" : "warning"}>{p.verifiedLandlord ? "verified landlord" : "landlord"}</Badge>}
                      {p.listings > 0 && <Badge>{p.listings} listing(s)</Badge>}
                      {p.status === "SUSPENDED" && <Badge tone="danger">suspended</Badge>}
                    </td>
                    <td className="px-3 py-2 text-muted-foreground">{day(p.createdAt)}</td>
                    <td className="px-3 py-2 text-muted-foreground">{day(p.lastActiveAt)}</td>
                    <td className="px-3 py-2 text-right">
                      {p.status === "ACTIVE" ? (
                        <ActionButton
                          variant="ghost"
                          confirm={`Suspend ${p.email}?`}
                          run={() => api("PUT", `/admin/users/${p.id}/status`, OkSchema, { status: "SUSPENDED" }).then(state.reload)}
                        >
                          Suspend
                        </ActionButton>
                      ) : (
                        <ActionButton variant="ghost" run={() => api("PUT", `/admin/users/${p.id}/status`, OkSchema, { status: "ACTIVE" }).then(state.reload)}>
                          Reinstate
                        </ActionButton>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Loaded>
    </div>
  );
}
